import {
  GET_CUSTOMER_CODES_FAILURE,
  GET_CUSTOMER_CODES_REQUEST,
  GET_CUSTOMER_CODES_SUCCESS,
  GET_PERMISSIONS_FAILURE,
  GET_PERMISSIONS_REQUEST,
  GET_PERMISSIONS_SUCCESS,
  GET_REFERENCE_NO_OPTIONS_REQUEST,
  GET_REFERENCES_FAILURE,
  GET_REFERENCE_NO_OPTIONS_SUCCESS,
  GET_REFERENCE_NO_OPTIONS_FAILURE,
  GET_REFERENCES_REQUEST,
  GET_REFERENCES_SUCCESS,
  GET_SERVICE_TYPE_LOOKUP_FAILURE,
  GET_SERVICE_TYPE_LOOKUP_REQUEST,
  GET_SERVICE_TYPE_LOOKUP_SUCCESS,
  GET_VENDORS_LIST_FAILURE,
  GET_VENDORS_LIST_REQUEST,
  GET_VENDORS_LIST_SUCCESS,
  RESET_MASTER_DATA_REDUCER,
} from "./actionTypes";
import {
  ArrayList,
  FailurePayload,
  GetCustomerCodesFailure,
  GetCustomerCodesRequest,
  GetCustomerCodesSuccess,
  GetPermissionsFailure,
  GetPermissionsRequest,
  GetPermissionsSuccess,
  GetReferenceNoOptionsFailure,
  GetReferenceNoOptionsRequest,
  GetReferenceNoOptionsSuccess,
  GetReferencesFailure,
  GetReferencesRequest,
  GetReferencesSuccess,
  GetServiceTypeLookupFailure,
  GetServiceTypeLookupRequest,
  GetServiceTypeLookupSuccess,
  GetVendorsListFailure,
  GetVendorsListRequest,
  GetVendorsListSuccess,
  ResetMasterDataReducer,
} from "./types";

export const getCustomerCodesRequest = (
  url: string,
  payload: any
): GetCustomerCodesRequest => ({
  type: GET_CUSTOMER_CODES_REQUEST,
  url,
  payload,
});

export const getCustomerCodesSuccess = (payload: {
  customerCodes: ArrayList[];
  customerDropdownBasedOnBillTo: ArrayList[];
  masterCustomerDropdownList: ArrayList[];
}): GetCustomerCodesSuccess => ({
  type: GET_CUSTOMER_CODES_SUCCESS,
  payload,
});

export const getCustomerCodesFailure = (
  payload: FailurePayload
): GetCustomerCodesFailure => ({
  type: GET_CUSTOMER_CODES_FAILURE,
  payload,
});

export const getPermissionsRequest = (url: string): GetPermissionsRequest => ({
  type: GET_PERMISSIONS_REQUEST,
  url,
});

export const getPermissionsSuccess = (payload: {
  permissions: ArrayList[];
}): GetPermissionsSuccess => ({
  type: GET_PERMISSIONS_SUCCESS,
  payload,
});

export const getPermissionsFailure = (
  payload: FailurePayload
): GetPermissionsFailure => ({
  type: GET_PERMISSIONS_FAILURE,
  payload,
});

export const resetMasterDataReducer = (): ResetMasterDataReducer => ({
  type: RESET_MASTER_DATA_REDUCER,
});

export const getVendorsListRequest = (
  url: string,
  payload: any
): GetVendorsListRequest => ({
  type: GET_VENDORS_LIST_REQUEST,
  url,
  payload,
});

export const getVendorsListSuccess = (payload: {
  vendorsList: ArrayList[];
  vendorCodes: ArrayList[];
  masterVendorDropdownList: ArrayList[];
}): GetVendorsListSuccess => ({
  type: GET_VENDORS_LIST_SUCCESS,
  payload,
});

export const getVendorsListFailure = (
  payload: FailurePayload
): GetVendorsListFailure => ({
  type: GET_VENDORS_LIST_FAILURE,
  payload,
});

export const getServiceTypeLookupRequest = (
  url: string
): GetServiceTypeLookupRequest => ({
  type: GET_SERVICE_TYPE_LOOKUP_REQUEST,
  url,
});

export const getServiceTypeLookupSuccess = (payload: {
  serviceTypeLookup: ArrayList[];
}): GetServiceTypeLookupSuccess => ({
  type: GET_SERVICE_TYPE_LOOKUP_SUCCESS,
  payload,
});

export const getServiceTypeLookupFailure = (
  payload: FailurePayload
): GetServiceTypeLookupFailure => ({
  type: GET_SERVICE_TYPE_LOOKUP_FAILURE,
  payload,
});

export const getReferencesRequest = (url: string): GetReferencesRequest => ({
  type: GET_REFERENCES_REQUEST,
  url,
});

export const getReferencesSuccess = (payload: {
  references: ArrayList[];
}): GetReferencesSuccess => ({
  type: GET_REFERENCES_SUCCESS,
  payload,
});

export const getReferencesFailure = (
  payload: FailurePayload
): GetReferencesFailure => ({
  type: GET_REFERENCES_FAILURE,
  payload,
});

export const getReferenceNoOptionsRequest = (url: string): GetReferenceNoOptionsRequest => ({
  type: GET_REFERENCE_NO_OPTIONS_REQUEST,
  url,
});

export const getReferenceNoOptionsSuccess = (payload: {
  referenceNoOptions: ArrayList[];
}): GetReferenceNoOptionsSuccess => ({
  type: GET_REFERENCE_NO_OPTIONS_SUCCESS,
  payload,
});

export const getReferenceNoOptionsFailure = (
  payload: FailurePayload
): GetReferenceNoOptionsFailure => ({
  type: GET_REFERENCE_NO_OPTIONS_FAILURE,
  payload,
});